import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  URL:string;
  TOKEN:string;
  versao: any;
  versaoAPI: any;

  constructor() { 
    this.URL = environment.url;
    this.versaoAPI = environment.versaoAPI;
    this.versao = environment.versao;
  }

  
  public getURLLogin(){

    return this.URL;    
}


  public getURL(){

      return this.URL + this.versaoAPI + '/';    
  }

  public getTOKEN(){
    return this.TOKEN;
  }

  public getVersao(){
    return this.versao;
  }
}